module.exports = __webpack_public_path__ + "img/application-illustration.883a1565.svg";